import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop"]

  open() {
    // Intercom is the front door now (Phelipe 2026-08-27) — the Support
    // link pops the same chat bubble that sits bottom-right. The priority
    // modal only opens when the messenger didn't load (ad-blocked,
    // offline), so nobody is ever left with no way to reach support.
    const ic = window.Intercom
    if (typeof ic === "function" && ic.booted) {
      ic("show")
      return
    }
    this.backdropTarget.classList.remove("hidden")
    document.addEventListener("keydown", this._closeOnEscape)
  }

  close() {
    this.backdropTarget.classList.add("hidden")
    document.removeEventListener("keydown", this._closeOnEscape)
  }

  closeOnBackdrop(event) {
    if (event.target === this.backdropTarget) {
      this.close()
    }
  }

  _closeOnEscape = (event) => {
    if (event.key === "Escape") {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this._closeOnEscape)
  }
}
